import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders, HttpParams } from '@angular/common/http';
import { url } from 'src/app/config/config';
import { map } from 'rxjs/operators';
import { Subject, Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class VariedadesService {

    public myVariedad = new Subject();
    

    public myurl = url+"variedades/";
    public httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json',
          'Authorization': localStorage.getItem("session")
        })
      };

      constructor(private http:HttpClient) {
        //console.log(this.myurl);
       }
       sendMyVariedad( value ) { 
         this.myVariedad.next( value );
       }
       public listVariedad(){
           
        return this.http.get(this.myurl+"listVariedad.php").pipe(map(data=>{
            return data;
        }));
       }

       createVariedad(variedad:any){
        let headers=new HttpHeaders();
        let body=JSON.stringify(variedad);
        console.log(variedad);
        headers.append('Content-Type' , 'application/json');
       
        return this.http.post(this.myurl+"createVariedad.php",body,{headers:headers}).pipe(map(resp=>{
          return resp;
        }));
      }
      listVariedadId(id){
        let headers=new HttpHeaders();
        let body=JSON.stringify({"id":id});
        headers.append('Content-Type' , 'application/json');
       
        return this.http.post(this.myurl+"getVariedadId.php",body,{headers:headers}).pipe(map(resp=>{
          return resp;
        }));
      }


      updateVariedad(variedad:any){
        let headers=new HttpHeaders();
        let body=JSON.stringify(variedad);
        headers.append('Content-Type' , 'application/json');
       
        return this.http.put(this.myurl+"updateVariedad.php",body,{headers:headers}).pipe(map(resp=>{
          return resp;
        }));
      }

      deleteVariedad(id){
        let headers=new HttpHeaders();
        headers.append('Content-Type', 'application/json');
        
        const params = new HttpParams()
        .set('id',id.toString());
        
        return this.http.delete(this.myurl+"deleteVariedad.php",{params}).pipe(map(data=>{
          return data;
        }));
      }
      
}